import React, { useState, lazy } from 'react';
import { MainContent, CommonContent } from '../../css/css';
import styled, { createGlobalStyle } from 'styled-components';

export const ConversationWrapper = styled.div`
  display: flex;
  background: white;
  height: 100%;
`;
export const LeftPart = styled.div`
  min-width: 220px;
  border-right: 1px solid #e9e9e9;
  overflow-y: auto;
  overflow-x: hidden;
  .ant-input-group-wrapper.ant-input-search{
    width: 200px;
  }
  .list-line, .active-line{
    line-height: 1;
    overflow: hidden;
  }
  .contact-list-line{
    min-width: 100%;
    width: unset;
  }
  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #e8ebf6;

    &:hover {
      background: #9a9eba;
    }
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 2px;
  }
`;
export const RightPart = styled.div`
  width: 100%;
`;
export const ConversationTitle = styled.div`
  height: 76px;
  width: 100%;
  display: flex;
  border-bottom: 1px solid #e9e9e9;
  padding: 16px 24px 0 24px;
`;
export const ConversationContent = styled.div`
  height: calc(100vh - 76px);
  overflow: hidden;
  .traff-searchBox{
    flex: 1;
    max-width: unset;
  }
  .ant-spin-nested-loading{
    width: 100%;
  }
  .infinite-scroll-component{
    border-top: none;
  }
`;
export const ConversationBottom = styled.div`
  height: 64px;
  width: 100%;
  background: white;
  box-shadow: 0px -2px 1px 0px rgba(0, 0, 0, 0.05);
`;

export const InfoBar = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  .cv-name {
    color: #595959;
    font-weight: 500;
    font-size: 14px;
  }
  .cv-corpName {
    margin-left: 8px;
    font-size: 12px;
    color: #bfbfbf;
  }
  .session-content {
    flex: 10;
  }
`;
export const IconWrapper = styled.div`
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  width: 24px;
  height: 24px;
  &.active {
    background: #fff2ea;
  }
`;
export const ShowIcon = styled.img`
  width: 10px;
  height: 10px;
  cursor: pointer;
`;
export const WhiteBackground = createGlobalStyle`
  body {
    .white-background .ant-tooltip-inner {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
`;
export const BoxHeader = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 16px 0 8px 0;
  cursor: pointer;
`;
export const ButtonItem = styled.div`
  padding: 0 4px;
  height: 24px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  color: #d9d9d9;
  margin-right: 8px;
  &.active {
    background: #fc8352;
    color: #fff;
    border: none;
    line-height: 24px;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #E9E9E9;
  position: relative;
  cursor: pointer;
  .ant-select {
    width: 160px;
    margin-right: 4px;
  }
  .ant-input-group-wrapper {
    margin-right: 4px;
  }
  .ant-input {
    height: 24px;
  }
  .ant-input-search-button {
    height: 24px;
  }
  .date-time {
    width: 71px;
    height: 24px;
    border-radius: 2px;
    border: 1px solid #D9D9D9;
    position: relative;
    .ant-picker.ant-picker-range{
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      &::after{
        display: block;
        content: '日期';
        width: 100%;
        text-align: right;
        white-space: nowrap;
        color: #595959;
      }
    }
  }
  .ant-picker-range-separator {
    display: none
  }
  .ant-picker-input {
    display: none
  }
  .ant-picker.ant-picker-borderless {
    padding: 0;
    width: 100%;
    height: 100%;
  }
`

export const DateName = styled.div`
  position: absolute;
  top: 0;
  right: 8px;
  white-space: nowrap;
  color: #595959;
`
export const SearchTime = styled.div`
  color: #BFBFBF;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const TimeClose = styled.img`
  width: 12px;
  height: 12px;
  margin-left: 8px;
`